/**
 * Manufacturing Capabilities — front end. Swaps the poster for the video
 * when the play button is clicked. Without JS the button is a normal link.
 */
( function () {
	document.addEventListener( 'click', function ( e ) {
		const button = e.target.closest( '.dlb-caps__play[data-src]' );
		if ( ! button ) {
			return;
		}
		e.preventDefault();

		const media = button.closest( '.dlb-caps__media' );
		let player;

		if ( button.dataset.videoType === 'embed' ) {
			player = document.createElement( 'iframe' );
			player.src = button.dataset.src;
			player.title = button.dataset.title || '';
			player.allow =
				'autoplay; encrypted-media; picture-in-picture; fullscreen';
			player.allowFullscreen = true;
		} else {
			player = document.createElement( 'video' );
			player.src = button.dataset.src;
			player.controls = true;
			player.autoplay = true;
			player.playsInline = true;
			player.setAttribute( 'aria-label', button.dataset.title || '' );
		}

		player.className = 'dlb-caps__player';
		media.classList.add( 'is-playing' );
		media.replaceChildren( player );
		player.focus();
	} );
} )();
